export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-quadtree/src/root.js
// module id = 355
// module chunks = 0 1 2 3 4